import { http } from '@/services/api/client';
import type {
  CreateDepartmentPayload,
  DepartmentRecord,
  DepartmentTreeNode,
  UpdateDepartmentPayload,
} from '@/types/department';

export async function fetchDepartmentTree(): Promise<DepartmentTreeNode[]> {
  return http.get('/departments/tree') as Promise<DepartmentTreeNode[]>;
}

export async function createDepartment(payload: CreateDepartmentPayload): Promise<DepartmentRecord> {
  return http.post('/departments', payload) as Promise<DepartmentRecord>;
}

export async function updateDepartment(
  id: string,
  payload: UpdateDepartmentPayload,
): Promise<DepartmentRecord> {
  return http.patch(`/departments/${id}`, payload) as Promise<DepartmentRecord>;
}

export async function deleteDepartment(id: string): Promise<{ success: true }> {
  return http.delete(`/departments/${id}`) as Promise<{ success: true }>;
}
